import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect } from "react";
import { $createParagraphNode, $getRoot, $getSelection, $isElementNode, $isRangeSelection, COMMAND_PRIORITY_EDITOR, OUTDENT_CONTENT_COMMAND, createCommand } from "lexical";
import { Box } from "../../../../../Box/index.js";
import { Icon } from "../../../../../Icon/index.js";
import { MenuItem } from "../../../../../MenuItem/index.js";
import { Typography } from "../../../../../Typography/index.js";
import { getSelectedNode } from "../../../utils/index.js";
const MAX_INDENT = 6;
const indentTypeToBlockName = {
    decrease: 'Уменьшить отступ',
    increase: 'Увеличить отступ'
};
const getIndentIcon = (indent)=>{
    switch(indent){
        case 'decrease':
            return /*#__PURE__*/ jsx(Icon, {
                name: "indent_decrease_outline",
                size: "20",
                color: "text.light.primary"
            });
        case 'increase':
            return /*#__PURE__*/ jsx(Icon, {
                name: "indent_increase_outline",
                size: "20",
                color: "text.light.primary"
            });
        default:
            return /*#__PURE__*/ jsx(Icon, {
                name: "indent_decrease_outline",
                size: "20",
                color: "text.light.primary"
            });
    }
};
const CUSTOM_INDENT_CONTENT_COMMAND = createCommand('CUSTOM_INDENT_CONTENT_COMMAND');
function registerMyCommand(editor) {
    return editor.registerCommand(CUSTOM_INDENT_CONTENT_COMMAND, ()=>{
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) return false;
        const nodes = selection.getNodes();
        for (const node of nodes){
            const element = $isElementNode(node) ? node : node.getParent();
            if (!element || !$isElementNode(element)) return false;
            if (element.getIndent && element.setIndent) {
                const indent = element.getIndent();
                if (indent < MAX_INDENT) element.setIndent(indent + 1);
            }
        }
        return true;
    }, COMMAND_PRIORITY_EDITOR);
}
const useIndentFormat = (editor)=>{
    const $ = c(8);
    let t0;
    let t1;
    if ($[0] !== editor) {
        t0 = ()=>{
            if (!editor) return;
            const unregister = registerMyCommand(editor);
            return ()=>{
                unregister();
            };
        };
        t1 = [
            editor
        ];
        $[0] = editor;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    useEffect(t0, t1);
    let t2;
    if ($[3] !== editor) {
        const handleIndentFormat = (indent)=>()=>{
                editor.update(()=>{
                    const selection = $getSelection();
                    if ($isRangeSelection(selection)) {
                        const node = getSelectedNode(selection);
                        const root = $getRoot();
                        if (null === node.getTopLevelElement()) {
                            const paragraph = $createParagraphNode();
                            root.append(paragraph);
                            paragraph.selectEnd();
                        }
                        if ("increase" === indent) return void editor.dispatchCommand(CUSTOM_INDENT_CONTENT_COMMAND, "");
                        if ("decrease" === indent) return void editor.dispatchCommand(OUTDENT_CONTENT_COMMAND, void 0);
                    }
                });
            };
        t2 = Object.entries(indentTypeToBlockName).map((t3)=>{
            const [indent_0, name] = t3;
            return /*#__PURE__*/ jsx(MenuItem, {
                onClick: handleIndentFormat(indent_0),
                children: /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    alignItems: "center",
                    gap: "8",
                    children: [
                        getIndentIcon(indent_0),
                        /*#__PURE__*/ jsx(Typography, {
                            variant: "body3",
                            children: name
                        })
                    ]
                })
            }, indent_0);
        });
        $[3] = editor;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = getIndentIcon("decrease");
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t2) {
        t4 = [
            t2,
            t3
        ];
        $[6] = t2;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
export { getIndentIcon, indentTypeToBlockName, useIndentFormat };
